export default __webpack_public_path__ + "static/media/image.fd99da89.png";